import {
  cellLineaRazonSocial, cellNotFilter,
  emptyCell, emptyCellOneLevel,
  EstadosPreagendamientoEnumChoice,
  formatDateWithTimeAMPM, formatDateWithTimeCell
} from "@/shared";
import { EstadoComponente } from "@/shared/components/ui";
import InfoUser from "@/shared/components/ui/InfoUser/InfoUser";
import { IPreagendamientoPymes } from "@/shared/interfaces/erp/ventas_pymes/preagendamiento_pymes.interface";
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";

const greenStates = [
  EstadosPreagendamientoEnumChoice.EN_ESPERA,
  EstadosPreagendamientoEnumChoice.FINALIZADO,
];

export const useTablePreagendamientoPymes = () => {


  const columnaPreagendamientoPymes = useMemo<MRT_ColumnDef<IPreagendamientoPymes>[]>(
    () => [
      {
        accessorKey: 'cliente_razon_social',
        header: 'Nombre',
        size: 300,
        Cell: ({ row }) => (
          cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_pymes_data.razon_social)
        ),
      },
      {
        accessorKey: 'identificacion',
        header: 'identificacion',
        size: 180,
        Cell: ({ row }) =>
          row.original?.prospecto_pymes_data?.identificacion || 'N/A',
      },
      {
        accessorKey: 'nombre_enlace',
        header: 'Nombre Enlace',
        size: 180,
      },
      {
        accessorKey: 'fecha_aceptacion',
        header: 'fecha aceptacion',
        size: 200,
        Cell: ({ row }) => (
          row.original.preventa_pymes_data.fecha_aceptacion != null ?
            formatDateWithTimeAMPM(row.original.preventa_pymes_data.fecha_aceptacion) : 'N/A'
        )
      },

      {
        ...cellNotFilter,
        accessorKey: 'estado_preagendamiento',
        header: 'Estado Preagendamiento',
        Cell: ({ row }) => (
          <EstadoComponente
            backgroundColor={greenStates.includes(row.original.estado_preagendamiento as EstadosPreagendamientoEnumChoice) ? 'green' : 'red'}
            texto={row.original?.estado_preagendamiento || 'N/A'}
          />
        ),
      },
      // -------------
      {
        ...cellNotFilter,
        accessorKey: 'direccion',
        header: 'direccion',
        size: 300,
        Cell: ({ row }) => row.original?.preventa_pymes_data?.direccion || 'N/A',
      },
      {
        ...cellNotFilter,
        accessorKey: 'fecha_hora_instalacion',
        header: 'FECHA Y HORA INSTALACION',
        size: 210,
        enableColumnFilter: true,
        enableSorting: true,
        Cell: ({ row }) =>
          `${row.original.fecha_instalacion} ${row.original.hora_instalacion}`,
      },
      /* {
        accessorKey: 'coordenadas',
        header: 'COORDENADAS',
        size: 210,
        Cell: ({ row }) => emptyCellOneLevel(row, 'coordenadas'),
      }, */
      {
        ...cellNotFilter,
        accessorKey: 'celular',
        header: 'CELULAR CLIENTE',
        size: 180,
        Cell: ({ row }) => row.original?.prospecto_pymes_data?.celular || 'N/A',
      },
      {
        ...cellNotFilter,
        accessorKey: 'celular_2',
        header: 'CELULAR 2',
        size: 180,
        Cell: ({ row }) => row.original?.preventa_pymes_data?.celular_2 || 'N/A',
      },

      // // plan ------------------
      {
        ...cellNotFilter,
        accessorKey: 'tipo_plan',
        header: 'Tipo Plan',
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_pymes_data?.tipo_plan || 'N/A';
        },
      },
      {
        ...cellNotFilter,
        accessorKey: 'tipo_servicio',
        header: 'Tipo de servicio',
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_pymes_data?.tipo_servicio || 'N/A';
        },
      },
      {
        ...cellNotFilter,
        accessorKey: 'plan',
        header: 'Plan de internet',
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_pymes_data.tipo_plan || 'N/A';
        },
      },
      /* {
        ...cellNotFilter,
        accessorKey: 'velocidad_internet',
        header: 'Velocidad de internet',
        size: 210,
        Cell: ({ row }) => {
          return row.original?.preventa_pymes_data?.velocidad
            ? `${row.original?.plan_data?.velocidad_subida_maxima} ${row.original?.plan_data?.unidad || ''
            }`
            : 'N/A';
        },
      }, */

      // flota & nap ------------------
      {
        accessorKey: 'flota',
        header: 'FLOTA',
        size: 180,
        Cell: ({ row }) => row.original?.flota_data?.nombre || 'N/A',
      },
      {
        ...cellNotFilter,
        accessorKey: 'canal_venta_create',
        header: 'Canal Venta',
      },

      {
        accessorKey: 'user_create',
        header: 'Asesor Venta',
        size: 200,
        Cell: ({ row }) => (
          <InfoUser
            user={row.original.user_create}
          />
        )
      },
      {
        accessorKey: 'fecha_creacion',
        header: 'Fecha de Creación',
        size: 200,
        enableColumnFilter: true,
        filterVariant: 'date',
        enableSorting: false,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion'),
      },
    ],
    []
  );

  const columnaPreRechazadoPreagendamientoPymes = useMemo<MRT_ColumnDef<IPreagendamientoPymes>[]>(
    () => [
      {
        accessorKey: 'identificacion',
        header: 'identificacion',
        size: 180,
        Cell: ({ row }) =>
          row.original?.prospecto_pymes_data?.identificacion || 'N/A',
      },
      {
        accessorKey: 'cliente_razon_social',
        header: 'Nombre',
        size: 300,
        Cell: ({ row }) => (
          cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_pymes_data.razon_social)
        ),
      },
      {
        accessorKey: 'nombre_enlace',
        header: 'Nombre Enlace',
        size: 250,
      },
      {
        accessorKey: 'preventa_pymes_data.representante_legal_razon_social',
        header: 'Representante Legal',
        size: 250,
      },
      {
        accessorKey: 'preventa_pymes_data.representante_celular1',
        header: 'Representante Legal Celular ',
        size: 250,
      },

      {
        ...cellNotFilter,
        accessorKey: 'observacion_llamada',
        header: 'Observación llamada',
        size: 350,
        Cell: ({ row }) => (
          row.original.observaciones != null
            ? row.original.observaciones.observacion_llamada != null
              ? row.original.observaciones.observacion_llamada
              : 'N/A'
            : 'N/A'
        )
      },
      {
        ...cellNotFilter,
        accessorKey: 'estado_preagendamiento',
        header: 'Estado Preagendamiento',
        Cell: ({ row }) => (
          <EstadoComponente
            backgroundColor={row.original.estado_preagendamiento === EstadosPreagendamientoEnumChoice.APROBADO ? 'green' : 'red'}
            texto={row.original?.estado_preagendamiento || 'N/A'}
          />
        ),
      },
      {
        accessorKey: 'motivo_rechazo',
        header: 'Motivo Rechazo',
        size: 200,
        Cell: ({ row }) => (
          emptyCell(row.original.motivo_rechazo_data?.nombre)
        )
      },
      {
        accessorKey: 'observacion_cancelacion',
        header: 'Observación Cancelación',
        size: 200,
        Cell: ({ row }) => (
          emptyCell(row.original.observaciones?.observacion_cancelacion)
        )
      },
      {
        ...cellNotFilter,
        accessorKey: 'fecha_hora_instalacion',
        header: 'FECHA Y HORA INSTALACION',
        size: 210,
        enableColumnFilter: true,
        enableSorting: true,
        Cell: ({ row }) =>
          `${row.original.fecha_instalacion} ${row.original.hora_instalacion}`,
      },

      ///* fk ========================================

      // flota & nap ------------------
      {
        accessorKey: 'flota',
        header: 'FLOTA',
        size: 180,
        Cell: ({ row }) => row.original?.flota_data?.nombre || 'N/A',
      },
      {
        accessorKey: 'nap_data_nombre',
        header: 'NAP',
        size: 180,
        Cell: ({ row }) => row.original?.nap_data.nombre || 'N/A',
      },
      {
        accessorKey: 'distancia',
        header: 'DISTANCIA A LA NAP',
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, 'distancia'),
      },




      {
        ...cellNotFilter,
        accessorKey: 'canal_venta_create',
        header: 'Canal Venta',
      },
      {
        accessorKey: 'user_create',
        header: 'Asesor Venta',
        size: 200,
        Cell: ({ row }) => (
          <InfoUser
            user={row.original.user_create}
          />
        )
      },
      {
        accessorKey: 'fecha_creacion',
        header: 'Fecha de Creación',
        size: 200,
        enableColumnFilter: true,
        filterVariant: 'date',
        enableSorting: false,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion'),
      },
      {
        accessorKey: 'fecha_modificacion',
        header: 'Fecha de Modificación',
        size: 200,
        enableColumnFilter: true,
        filterVariant: 'date',
        enableSorting: false,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_modificacion'),
      },
    ],
    []
  );

  return {
    columnaPreagendamientoPymes,
    columnaPreRechazadoPreagendamientoPymes
  }
}